/**
 *
 * @param {Map<any, any>} elements
 * @param {"isMain" | "isGroup" | "isContainer"} type
 * @returns {Array<MainClassProps | GroupClassProps | ContainerClassProps>}
 */
const filterInstances = (elements, type) => {
  return /** @type {Array<MainClassProps | GroupClassProps>} */ (
    [...elements.values()].filter((item) => item[type])
  );
};

export default filterInstances;
